import './checkbox.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

const Checkbox = props => {
	return (
		<div className="form-element-checkbox">
			<div className={cn({
				'checkbox': true,
				'is-disabled': props.disabled
			})}>
				<input
					type="checkbox"
					id={props.input.name}
					checked={!!props.input.value}
					disabled={props.disabled}
					{...props.input} />
				<label
					htmlFor={props.input.name} className={cn({ 'show-when-disabled': props.needShowWhenDisabled })}
				/>
			</div>
			{ props.placeholder && (
				<label htmlFor={props.input.name} className="label-name">
					{props.placeholder}
				</label>
			) }
			{props.meta && props.meta.touched && props.meta.error && (
				<div className="form-element-error"><span>{ props.meta.error }</span></div>
			)}
		</div>
	);
};

Checkbox.propTypes = {
	input: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	meta: PropTypes.object
};

export default Checkbox;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/checkbox.js